module.exports = __webpack_public_path__ + "components/rating/static/star-half-e23b06e292b4f3c9e1fb031d35504d2a.svg";